<template>
  <section class="form-list">
    <el-form
      ref="form"
      :rules="rules"
      :model="post"
      label-position="right"
      label-width="130px"
      class="form"
    >
      <el-form-item label="标签名称" prop="course_tag_name">
        <el-input v-model="post.course_tag_name" maxlength="32" placeholder="请输入 32 字符以内的标签名称" show-word-limit clearable/>
      </el-form-item>
      <v-image-upload
        v-model="post.course_tag_name_img"
        label="标签名称图片"
        prefix="course-tag-name-img"
        ratio="25:4"
        prop-name="course-tag-name-img"
        :is-edit="true"
        :is-show-close="true"
        alert="上传标签名称图片后，标签名称将不再显示，以本图片取而代之"
      />

      <v-image-upload
        v-model="post.cover"
        label="标签封面"
        prefix="course-tags"
        ratio="16:9"
        prop-name="cover"
        :is-edit="true"
      />
      <el-form-item label="不在课程列表展示">
        <el-switch v-model="post.is_hide_in_list" :active-value="1" :inactive-value="0"/>

        <el-alert
          title="此功能默认关闭，开启后，标签所属课程在小程序的首页课表、门店课表、老师课表均不展示"
          type="info"
          show-icon
          :closable="false"
        />
      </el-form-item>

      <el-form-item label="仅工作人员可分享">
        <el-switch v-model="post.is_staff_share_only" :active-value="1" :inactive-value="0"/>

        <el-alert
          title="此功能默认关闭，开启后，标签所属课程在小程序的分享功能将仅限后台系统录入的工作人员使用"
          type="info"
          show-icon
          :closable="false"
        />
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="handleSubmit" :loading="isSaving">保存修改</el-button>
        <el-button @click="RouteConfig.courseTagList.back">返回</el-button>
      </el-form-item>
    </el-form>
  </section>
</template>

<script>
  import RouteConfig from '@/router/config';
  import { show, update } from '@/api/course-tag';

  export default {
    name: RouteConfig.courseTagEdit.name,
    data: () => ({
      RouteConfig,
      isSaving: false,
      post: {
        course_tag_name: '',
        cover: '',
        course_tag_name_img: '',
        update_time: 0,
        is_hide_in_list: 0,
        is_staff_share_only: 0,
      },
      rules: {
        course_tag_name: [{ required: true, message: '请输入标签名称', trigger: 'change' }],
        cover: [{ required: true, message: '请上传标签封面', trigger: 'change' }],
      },
    }),
    computed: {
      id() {
        return +this.$route.params.id || 0;
      },
    },
    beforeMount() {
      this.show();
    },
    methods: {
      async show() {
        const { isError, data } = await show(this.id);
        if (isError) return;

        const { post } = this;
        const newPost = {};
        Object.keys(data).forEach(key => {
          if (key in post) newPost[key] = data[key];
        });
        Object.assign(post, newPost);
      },
      handleSubmit() {
        if (this.isSaving) return;

        this.$refs.form.validate(async (isSuccess) => {
          if (!isSuccess) return;

          const post = { ...this.post };
          this.isSaving = true;
          const { isError } = await update(this.id, post);
          this.isSaving = false;
          if (!isError) RouteConfig.courseTagList.back();
        });
      },
    },
  };
</script>
